var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-app',[_c('v-app-bar',{attrs:{"app":"","color":"primary","dark":""}},[_c('div',{staticClass:"d-flex align-center"},[_c('h2',[_vm._v("Secure SSH Key generator")])])]),_c('v-content',[_c('SshKeygen')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }